var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgHelpChecklist = function SvgHelpChecklist(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 323,
    height: 134,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.69,
    d: "M389.572 188.664c67.315-67.315 67.315-176.453 0-243.768s-176.453-67.315-243.768 0-67.315 176.453 0 243.768 176.453 67.315 243.768 0z",
    fill: "url(#help-checklist_svg__paint0_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4,
    d: "M288.719 119.704c27.755-27.755 27.755-72.754 0-100.508-27.754-27.755-72.753-27.755-100.508 0-27.754 27.754-27.754 72.753 0 100.508 27.755 27.754 72.754 27.754 100.508 0z",
    fill: "url(#help-checklist_svg__paint1_radial)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.71,
    d: "M263.785 71.71V41.6a9.752 9.752 0 00-9.74-9.74h-47.76a9.75 9.75 0 00-9.74 9.74v30.11a9.752 9.752 0 009.74 9.74h47.81a9.749 9.749 0 009.69-9.74zm-57.5-34.53h47.81a4.41 4.41 0 014.36 3.8l-27.88 15.91a.92.92 0 01-.88 0l-27.83-15.86a4.428 4.428 0 014.42-3.85zm-4.43 34.53V47.03l25.26 14.44a6.18 6.18 0 003.07.81c1.079 0 2.14-.279 3.08-.81l25.21-14.44v24.68a4.433 4.433 0 01-4.43 4.42h-47.76a4.428 4.428 0 01-4.48-4.42h.05zm80.57-5.32V96.5a9.752 9.752 0 01-9.74 9.74h-30.7l-9 9.76a2.68 2.68 0 01-2 .86 2.649 2.649 0 01-2.69-2.65v-8h-4.43a9.752 9.752 0 01-9.74-9.74v-8.83a2.66 2.66 0 115.32 0v8.86a4.429 4.429 0 004.42 4.43h7.09a2.65 2.65 0 012.65 2.65v3.8l5.13-5.59a2.625 2.625 0 012-.86h31.87a4.442 4.442 0 004.43-4.43V66.39a4.433 4.433 0 00-4.43-4.42h-2.62a2.659 2.659 0 110-5.31h2.65a9.743 9.743 0 019.74 9.73h.05z",
    fill: "url(#help-checklist_svg__paint2_radial)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M263.785 71.71V41.6a9.752 9.752 0 00-9.74-9.74h-47.76a9.75 9.75 0 00-9.74 9.74v30.11a9.752 9.752 0 009.74 9.74h47.81a9.749 9.749 0 009.69-9.74zm-57.5-34.53h47.81a4.41 4.41 0 014.36 3.8l-27.88 15.91a.92.92 0 01-.88 0l-27.83-15.86a4.428 4.428 0 014.42-3.85zm-4.43 34.53V47.03l25.26 14.44a6.18 6.18 0 003.07.81c1.079 0 2.14-.279 3.08-.81l25.21-14.44v24.68a4.433 4.433 0 01-4.43 4.42h-47.76a4.428 4.428 0 01-4.48-4.42h.05zm80.57-5.32V96.5a9.752 9.752 0 01-9.74 9.74h-30.7l-9 9.76a2.68 2.68 0 01-2 .86 2.649 2.649 0 01-2.69-2.65v-8h-4.43a9.752 9.752 0 01-9.74-9.74v-8.83a2.66 2.66 0 115.32 0v8.86a4.429 4.429 0 004.42 4.43h7.09a2.65 2.65 0 012.65 2.65v3.8l5.13-5.59a2.625 2.625 0 012-.86h31.87a4.442 4.442 0 004.43-4.43V66.39a4.433 4.433 0 00-4.43-4.42h-2.62a2.659 2.659 0 110-5.31h2.65a9.743 9.743 0 019.74 9.73h.05z",
    fill: "#F2F2F2",
    opacity: 0.11
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "help-checklist_svg__paint0_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -172.37 172.37 0 267.694 66.778)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#206A72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#0D2B2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "help-checklist_svg__paint1_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 -71.07 71.07 0 238.469 69.445)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6DF7C6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#429679",
    stopOpacity: 0.61
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "help-checklist_svg__paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(239.435 74.36) scale(42.72)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#80EDF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357176"
  })))));
};

export default SvgHelpChecklist;